"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withValue = exports.withMutable = exports.withFuncs = void 0;
var controller_1 = require("./controller");
function withFuncs(value, onChange) {
    return new controller_1.ControllerImpl(function () { return ({
        setValue: onChange,
        value: value(),
    }); });
}
exports.withFuncs = withFuncs;
function withMutable(value) {
    return new controller_1.ControllerImpl(function () { return ({
        setValue: function (newValue) {
            for (var i in value) {
                if (Object.prototype.hasOwnProperty.call(value, i)) {
                    delete value[i];
                }
            }
            for (var i in newValue) {
                if (Object.prototype.hasOwnProperty.call(newValue, i)) {
                    value[i] = newValue[i];
                }
            }
        },
        value: value,
    }); });
}
exports.withMutable = withMutable;
function withValue(value) {
    var myValue = value;
    return new controller_1.ControllerImpl(function () { return ({
        value: myValue,
        setValue: function (newValue) {
            myValue = newValue;
        },
    }); });
}
exports.withValue = withValue;
